export * from './useGlobalVars';
